"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7358],{

/***/ 77358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WelcomeToOurTeam; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/sections/WelcomeToOurTeam/welcomeToOurTeam.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n    margin-bottom: 2.375rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-rows: 1fr;\n    grid-template-columns: auto auto;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: 27.75rem;\n    display: grid;\n    grid-template-rows: auto auto;\n    grid-auto-flow: column;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: 13.25rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 13.25rem;\n    "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 23.125rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 23.125rem;\n    "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}



const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1qyylr90"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qyylr91"
})("display:flex;flex-direction:column;", mixins/* defaultContainerSize */.sX, ";padding-top:6.5rem;padding-bottom:6.5rem;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1qyylr92"
})("font-weight:400;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:2rem;line-height:2.5rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0 0 1.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Text = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1qyylr93"
})("font-size:1rem;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";letter-spacing:0.0125rem;font-weight:300;margin:0 0 2.125rem 0;max-width:41.875rem;");
const Bold = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("strong", {
    target: "e1qyylr94"
})("font-weight:700;");
const Grid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qyylr95"
})("display:grid;grid-template-columns:1fr;grid-template-rows:auto auto;gap:1.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const ImagesContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qyylr96"
})("position:relative;display:flex;gap:0.5rem;overflow-x:scroll;max-height:13.9375rem;padding-bottom:1rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";::-webkit-scrollbar{height:5px;}/* Track */::-webkit-scrollbar-track{background:transparent;}/* Handle */::-webkit-scrollbar-thumb{background:#888;}/* Handle on hover */::-webkit-scrollbar-thumb:hover{background:#555;}");
const ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qyylr97"
})("width:100%;height:100%;min-width:17.90625rem;min-height:12.9375rem;max-width:17.90625rem;max-height:12.9375rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";img{max-width:17.90625rem;max-height:12.9375rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";}");
const VideoImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qyylr98"
})("position:relative;width:100%;min-width:100%;max-width:21.4375rem;min-height:25rem;max-height:26.6875rem;border-radius:0.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";img{border-radius:0.5rem;min-width:100%;max-width:21.4375rem;min-height:25rem;max-height:26.6875rem;object-fit:cover;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";}");
const PlayButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1qyylr99"
})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:2rem;max-width:5.5rem;max-height:5.5rem;border:none;box-shadow:none;background-image:linear-gradient(\n    100.54deg,#0e4ed7 0%,#7b4b93 48.44%,#f94743 100%\n  );border-radius:100%;");

;// CONCATENATED MODULE: ./utils/htmlSerializers/careersHtmlSerializer.ts



const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const careersHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            props = {};
            return react.createElement(Text, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.strong:
            props = {};
            return react.createElement(Bold, propsWithUniqueKey(props, key), children);
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./components/images/PlayImages/PlayImages.tsx
var PlayImages = __webpack_require__(75987);
// EXTERNAL MODULE: ./components/sections/Integration/Integration.tsx + 1 modules
var Integration = __webpack_require__(50365);
;// CONCATENATED MODULE: ./components/sections/Integration/index.ts

/* harmony default export */ var sections_Integration = (Integration/* Integration */.Y);

// EXTERNAL MODULE: ./components/sections/Integration/useMeetingVideo.ts
var useMeetingVideo = __webpack_require__(65174);
;// CONCATENATED MODULE: ./components/sections/WelcomeToOurTeam/WelcomeToOurTeam.tsx









const WelcomeToOurTeam = (param)=>{
    let { title , titleAs , description , mainImage , images  } = param;
    const { handlePlayVideo , isFullscreen , handleClose , videoRef  } = (0,useMeetingVideo/* useMeetingVideo */.s)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                    render: description,
                    htmlSerializer: careersHtmlSerializer
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoImageContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    ...(0,imageSerializer/* imageSerializer */.l)(mainImage)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButton, {
                                    onClick: handlePlayVideo,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayImages/* PlayIconWhite */.u, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_Integration, {
                            ref: videoRef,
                            isFullscreen: isFullscreen,
                            handleClose: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImagesContainer, {
                            children: images.map((param, index)=>/*#__PURE__*/ {
                                let { welcome_image  } = param;
                                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        ...(0,imageSerializer/* imageSerializer */.l)(welcome_image)
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/WelcomeToOurTeam/index.ts

/* harmony default export */ var sections_WelcomeToOurTeam = (WelcomeToOurTeam);


/***/ })

}]);